<template>
  <v-container fill-height fluid @click="navTriggle">
    <v-layout text-center align-center flex-column justify-center>
      <!-- <v-flex xs12 sm8 md3>
        <v-img :src="require('../assets/logo.svg')" class="mt-3" contain height="200"></v-img>
      </v-flex> -->
      <v-flex xs12 sm8 md3>
        <HomeLogo />
      </v-flex>
      <v-flex xs12 sm8 md4>
        <h1 class="display-2 font-weight-bold mb-3">
          <span :style="{ color: setting.COLOR }">Welcome</span>
          <span :style="{ color: setting.BACKGROUNDCOLOR }"> to </span>
          <span :style="{ color: setting.COLOR }">CBox</span>
        </h1>
        <p class="subheading font-weight--regular text-h4">
          <strong :style="{ color: setting.BACKGROUNDCOLOR }">C</strong
          >linical
          <strong :style="{ color: setting.BACKGROUNDCOLOR }">T</strong
          >rial
          <strong :style="{ color: setting.BACKGROUNDCOLOR }">B</strong
          >ox
        </p>
        <div class="d-flex justify-center align-end mt-5 pa-5">
          <span class="display-3 mr-2">{{ strDay }}</span>
          <span class="title">{{ strMonth }}</span>
          <v-divider class="mx-4" inset vertical></v-divider>
          <span class="body-1" :style="{ color: objDaily.COLOR }">{{
            objDaily.TEXT
          }}</span>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import HomeLogo  from "../components/HomeLogo";


export default {
  name: "HomePage",
  components: {
    HomeLogo,
  },
  data: () => ({
    strMonth: null,
    strDay: null,
    objDaily: {},
  }),
  methods: {
    navTriggle() {
      this.$store.commit("updateDrawer");
    },
  },
  props: {
  },
  created() {
    this.objDaily.TEXT =
      "However bad life may seem, there is always something you can do, and succeed at.";
    this.strMonth = new Date().toDateString().split(" ")[1];
    this.strDay = new Date().toDateString().split(" ")[2];
  },
  computed: mapState({
    setting: "setting",
  }),
};
</script>
